export const MIN_RMS_DB = -50;
export const MIN_MOS_SIG = 2.0;
export const MIN_MOS_BAK = 3;
export const MIN_MOS_OVR = 1.856;
export const MIN_SPEECH_DURATION_SEC = 1;
export const MIN_SPEECH_RATIO = 0.4;
export const MIN_SPINNER_MS = 1500;

export function getOrtWasmBase() {
  const publicUrl = process.env.PUBLIC_URL || "";
  const base = publicUrl.endsWith("/") ? publicUrl : `${publicUrl}/`;
  return `${base}vad/ort/`;
}

export function getAudioQualityThresholds() {
  return {
    min_rms_db: MIN_RMS_DB,
    min_speech_ratio: MIN_SPEECH_RATIO,
    min_speech_duration_sec: MIN_SPEECH_DURATION_SEC,
    min_mos_sig: MIN_MOS_SIG,
    min_mos_bak: MIN_MOS_BAK,
    min_mos_ovr: MIN_MOS_OVR,
  };
}
